module.exports = __webpack_public_path__ + "media/images/banner-help-center@2x-1e1e23658af2a4359f4cf2705f190c09.jpg";